import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from 'seagull';
import { handlePromise } from '~/infra/utils';
function RemindersConfirmation(param) {
    let { count, texts } = param;
    return /*#__PURE__*/ _jsxs(Typography, {
        children: [
            texts.sendRemindersConfirmationPrefix(),
            " ",
            /*#__PURE__*/ _jsx("strong", {
                children: count
            }),
            " ",
            texts.sendRemindersConfirmationSuffix()
        ]
    });
}
export const bulkRemindersRequest = (param)=>{
    let { proposalIds, texts, sendReminder, onConfirmed, onFailedIds } = param;
    return {
        bulkItemIds: [
            ...proposalIds
        ],
        confirmation: {
            title: texts.sendRemindersInBulkTitle(),
            primaryButtonLabel: texts.sendRemindersButton(),
            content: /*#__PURE__*/ _jsx(RemindersConfirmation, {
                count: proposalIds.length,
                texts: texts
            })
        },
        progressTitle: texts.sendRemindersProgressTitle(),
        actionName: 'sent',
        itemName: texts.sendRemindersItemName(),
        onConfirmed,
        canProcessItem: ()=>true,
        processSingleItem: (proposalId)=>handlePromise(sendReminder(proposalId)),
        onDone: onFailedIds
    };
};
